import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Container, Eyebrow, Heading } from '../ui/Section';
import { ClientLogosCarousel, ProofStats } from '../features/ClientsProof';
export function ProofSection() {
  return <section className="bg-white py-20 md:py-28" data-id="element-353" data-mp="34xk1oyw3mcb9">
      <Container data-id="element-354" data-mp="39t95jef5ifdd">
        <div className="grid gap-12 lg:grid-cols-[1fr_1fr] lg:gap-20" data-id="element-355" data-mp="39tr4iit777oz">
          <div data-id="element-356" data-mp="2c7li3j0ob7dz">
            <Eyebrow data-id="element-357" data-mp="2c7trv21i1wky">Clientes y experiencia</Eyebrow>
            <Heading as="h2" size="lg" className="mt-5" data-id="element-358" data-mp="2h5d827hrcjfj">
              Operaciones sostenidas en el tiempo.
            </Heading>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-graphite-500" data-id="element-359" data-mp="2m3ogqewbgnw6">
              Trabajamos con empresas que necesitan continuidad operativa, cumplimiento y trazabilidad. Publicamos
              únicamente clientes, casos e indicadores verificados por la empresa.
            </p>
            <Link to="/clientes" className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-brand-700 transition-colors duration-150 hover:text-brand-600" data-id="element-360" data-mp="6cisifl5j226">
              Ver clientes y casos
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-361" data-mp="2ai8o4172bk7l" />
            </Link>
          </div>
          <ProofStats data-id="element-362" data-mp="26kaywydaky47" />
        </div>

        <div className="mt-16 border-t border-mist-200 pt-10" data-id="element-363" data-mp="21k6eix99jj8p">
          <ClientLogosCarousel data-id="element-364" data-mp="1wkaa4wwnlpsm" />
        </div>
      </Container>
    </section>;
}